import axios from "axios";
import { url, port, version } from "../../config/config";
import { Endpoint, Params, Payload, Headers } from "../../types/api/api.types";
import axiosInstance from "../commonFunctions/axiosInstace";

const get = async (
	endpoint: Endpoint,
	headers: Headers = {},
	params: Params = {},
	_port: number | undefined = undefined
) => {
	try {
		const newPort = _port ? _port : port;
		const response = await axiosInstance.get(`${url}:${port}/api/${version}/${endpoint}`, {
			headers,
			params
		});
		const { status } = response;
		if (status === 200) {
			return response;
		}
	} catch (error) {
		// console.log("error", error);
		throw error;
	}
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const post = async (endpoint: Endpoint, payload: any, headers: Headers) => {
	try {
		const response = await axiosInstance.post(`${url}:${port}/api/${version}/${endpoint}`, payload, {
			headers
		});
		const { status } = response;
		if (status === 200) {
			return response;
		}
	} catch (error) {
		// console.log("error", error);
		throw error;
	}
};

const put = async (endpoint: Endpoint, payload: any, headers: Headers) => {
	try {
		const response = await axiosInstance.put(`${url}:${port}/api/${version}/${endpoint}`, payload, {
			headers
		});
		const { status } = response;
		if (status === 200) {
			return response;
		}
	} catch (error) {
		// console.log("error", error);
		throw error;
	}
};

const patch = async (endpoint: Endpoint, payload: Payload, headers: Headers) => {
	try {
		const response = await axiosInstance.patch(`${url}:${port}/api/${version}/${endpoint}`, payload, {
			headers
		});
		const { status } = response;
		if (status === 200) {
			return response;
		}
	} catch (error) {
		// console.log("error", error);
		throw error;
	}
};

const del = async (endpoint: Endpoint, headers: Headers) => {
	try {
		const response = await axiosInstance.delete(`${url}:${port}/api/${version}/${endpoint}`, {
			headers
		});
		const { status } = response;
		if (status === 200) {
			return response;
		}
	} catch (error) {
		// console.log("error", error);
		throw error;
	}
};

export const request = {
	get,
	post,
	put,
	del,
	patch
};
